const initResultObject = (
    isSuccess = false,
    errors = [],
    data = null,
    message = '',
    statusCode = null
  ) => {
    return { isSuccess, errors, data, message, statusCode }
  }
  
  /**
   * Successful operation. isSuccess is set to true
   * @param {*} data
   * @param {String} msg
   * @param {Number} statusCode
   * @returns
   */
  export const success = (data = null, msg = '', statusCode = 200) =>
    initResultObject(true, [], data, msg, statusCode)
  
/**
 * Failed operation. isSuccess is set to false
 * @param {Object} error
 * @param {String} msg
 * @param {Number} statusCode
 * @returns
 */
export const fail = (error = null, msg = '', statusCode = 400) =>
  initResultObject(false, error, null, msg, statusCode)